import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { useSesionStore } from '@/entities/usuario';
import { LoginMfaSetupPage } from '@/pages/login-mfa-setup';

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/_public/login/mfa-setup')({
  validateSearch: searchSchema,
  beforeLoad: () => {
    if (!useSesionStore.getState().mfaEnrollmentToken) {
      // TanStack Router usa `throw redirect(...)` como señal de flujo.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({ to: '/login' });
    }
  },
  component: LoginMfaSetupPage,
});
